import React from "react";
// @ts-ignore
import ReactDOM from "react-dom/client";
import "./i18n";
import "./fonts/Manrope-VariableFont_wght.ttf";
import "./font.css";
import "./utils.css";
import "./index.css";
import "leaflet/dist/leaflet.css";
import App from "./containers/App/App";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// uncomment to enable react-scan and react-query-devtools for debugging
//import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
//import { scan } from "react-scan"; // must be imported before React and React DOM
//scan({
//  enabled: true,
//});

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      staleTime: Infinity,
      retry: 0,
    },
  },
});
const container = document.getElementById("root");
// @ts-ignore
const root = ReactDOM.createRoot(container);

root.render(
  <QueryClientProvider client={client}>
    {/*<ReactQueryDevtools initialIsOpen={false} />*/}

    <BrowserRouter>
      <App />
    </BrowserRouter>
  </QueryClientProvider>
);
